<template>
  <div class="Intro">
    <div class="BrandBlock">
      <router-link
        :to="{ name: 'home' }"
        class="SiteName"
        tag="div"
      >
        <a>Библиотека</br>фасилитатора</a>
      </router-link>
			<div class="SitePodpis">Методы, инструменты, технологии...</div>
      <!-- <div class="InfoBt" @click="goTo('about')">Что это</br>такое?</div> -->
      <router-link
        :to="{ name: 'about' }"
        tag="div"
        class="InfoBt"
      >
        <a>Что это</br>такое?</a>
      </router-link>
      <div class="UsersBt" @click="goTo('users')">Список</br>участников</div>
      <div class="Frases">
        <div class=Frasa>Методы, инструменты </br>и технологии фасилитации </br>на все случаи жизни !!!</div>
      </div>
		</div>
    <div class="MethodMenu" id="Menu">
      <table align="center" width="85%" height="60px" border="0">
      <tr>
        <td id="M1"><router-link class="Mbt" tag="div" :to="{ name: 'home' }"><a>ОСНОВЫ</br>ФАСИЛИТАЦИИ</a></router-link></td>
        <td id="M2"><router-link class="Mbt" tag="div" :to="to('tag', { id: 1 })"><a>ОТКРЫТИЕ</br>СЕССИИ<div class="TSum">{{ tagCardsCount[1] }}</div></a></router-link></td>
        <td id="M3"><router-link class="Mbt" tag="div" :to="to('tag', { id: 2 })"><a>ВИДЕНИЕ</br>БУДУЩЕГО<div class="TSum">{{ tagCardsCount[2] }}</div></a></router-link></td>
        <td id="M4"><router-link class="Mbt" tag="div" :to="to('tag', { id: 3 })"><a>АНАЛИЗ</br>СИТУАЦИИ<div class="TSum">{{ tagCardsCount[3] }}</div></a></router-link></td>
        <td id="M5"><router-link class="Mbt" tag="div" :to="to('tag', { id: 4 })"><a>ГЕНЕРАЦИЯ</br>ИДЕЙ<div class="TSum">{{ tagCardsCount[4] }}</div></a></router-link></td>
        <td id="M6"><router-link class="Mbt" tag="div" :to="to('tag', { id: 5 })"><a>ВЫБОР</br>РЕШЕНИЯ<div class="TSum">{{ tagCardsCount[5] }}</div></a></router-link></td>
        <td id="M7"><router-link class="Mbt" tag="div" :to="to('tag', { id: 6 })"><a>ПЛАН</br>ДЕЙСТВИЙ<div class="TSum">{{ tagCardsCount[6] }}</div></a></router-link></td>
        <td id="M8"><router-link class="Mbt" tag="div" :to="to('tag', { id: 7 })"><a>ЗАВЕРШЕНИЕ</br>СЕССИИ<div class="TSum">{{ tagCardsCount[7] }}</div></a></router-link></td>
        <td id="M9"><router-link class="Mbt" tag="div" :to="to('tag', { id: 8 })"><a>И ЕЩЁ...</br>&nbsp <div class="TSum">{{ tagCardsCount[8] }}</div></a></router-link></td>
        <!-- <td id="M10"><div class="Mbt" style="background-image: url('../assets/img/mbt10.png'); background-position: left top; background-repeat: no-repeat;">ТЕМАТИЧЕСКИЕ</br>МЕТОДЫ</div></td> -->
      </tr>
    </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['tags']),
    tagCardsCount() {
      return Object.fromEntries(
               this.tags.map(
                 tag => [tag.id, tag.cards_count]
               )
             )
    }
  }
};
</script>

<style>
.Intro{
  position: relative;
  padding-top: 30px;
  left: 0px;
  min-width: 1300px;
  width: 100%;
  height: 300px;
  border-bottom: 1px solid #ccc;
  background-color: #FFF;
  z-index: 4;
  background-image: url('/img/test-fon.jpg');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.BrandBlock{
	position: relative;
	margin: 0px auto;
	width: 1000px;
	height: 200px;
	border: 0px solid #ccc;
}

.SiteName{
	left: 0px;
	top: 0px;
	padding-top: 20px;
	width: 450px;
	height: 125px;
	border: 0px solid #ccc;
}

.SiteName a{
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 68px;
  line-height: 0.9;
  color: #37bbd6;
  text-decoration: none;
}

.SitePodpis{
	left: 0px;
	padding-top: 10px;
	width: 450px;
	height: 30px;
	border: 0px solid #ccc;
	font-family: 'Caveat', cursive;
	font-size: 30px;
	line-height: 1;
	color: #000000;
}

.InfoBt{
  position: absolute;
  left:340px;
  top: 6px;
  width: 60px;
  height: 50px;
  padding-top: 32px;
  padding-left: 42px;
  border: 0px solid #ccc;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  line-height: 1.1;
  background-image: url('/img/info-icon-off-small.png');
  background-position: left top;
  background-repeat: no-repeat;
}
.InfoBt:hover{
  background-image: url('/img/info-icon-on-small.png');
}

.InfoBt a{
  color: #9e9e9e;
  text-decoration: none;
}
.InfoBt:hover a{
  color: #000000;
}

.UsersBt{
  position: absolute;
  left:880px;
  top: 6px;
  width: 75px;
  height: 35px;
  padding-top: 32px;
  padding-left: 25px;
	border: 0px solid #ccc;
	font-family: 'Roboto', sans-serif;
	font-size: 13px;
	line-height: 1.1;
  color: #9e9e9e;
  background-image: url('/img/users-icon-off.png');
  background-position: left top;
  background-repeat: no-repeat;
  cursor:pointer;
}

.UsersBt:hover{
  color: #000000;
  background-image: url('/img/users-icon-on.png');
}

.Frases{
  position: absolute;
  left:540px;
  top: 6px;
  width: 300px;
  height: 150px;
  /* padding-top: 32px;
  padding-left: 42px; */
	border: 0px solid #ccc;

}

.Frasa{
  position: absolute;
  padding-top: 55px;
  font-family: 'Roboto Condensed', sans-serif;
	font-size: 24px;
	line-height: 1.1;
  color: #000000;
}

.MethodMenu{
  position: absolute;
  bottom: 5px;
  left: 0px;
  min-width: 1300px;
  width: 100%;
  height: 70px;
}

.TSum{
  position: absolute;
  top: 8px;
  left: 27px;
  font-family: 'Open Sans', sans-serif;
  font-size: 10px;
  color: #b6b6b6;
}

#M1 .Mbt{
  background-image: url('../assets/img/fbt-0.png');
  background-position: left top;
  background-repeat: no-repeat;
  cursor:pointer;
}

#M2 .Mbt{
  background-image: url('../assets/img/fbt-1.png');
  background-position: left top;
  background-repeat: no-repeat;
  cursor:pointer;
}

#M3 .Mbt{
  background-image: url('../assets/img/fbt-2.png');
  background-position: left top;
  background-repeat: no-repeat;
  cursor:pointer;
}

#M4 .Mbt{
  background-image: url('../assets/img/fbt-3.png');
  background-position: left top;
  background-repeat: no-repeat;
  cursor:pointer;
}

#M5 .Mbt{
  background-image: url('../assets/img/fbt-4.png');
  background-position: left top;
  background-repeat: no-repeat;
  cursor:pointer;
}

#M6 .Mbt{
  background-image: url('../assets/img/fbt-5.png');
  background-position: left top;
  background-repeat: no-repeat;
  cursor:pointer;
}

#M7 .Mbt{
  background-image: url('../assets/img/fbt-6.png');
  background-position: left top;
  background-repeat: no-repeat;
  cursor:pointer;
}

#M8 .Mbt{
  background-image: url('../assets/img/fbt-7.png');
  background-position: left top;
  background-repeat: no-repeat;
  cursor:pointer;
}

#M9 .Mbt{
  background-image: url('../assets/img/fbt-8.png');
  background-position: left top;
  background-repeat: no-repeat;
  cursor:pointer;
}

.Mbt{
  position: relative;
  margin: 0px auto;
  padding-top: 30px;
  padding-left: 7px;
  line-height: 1.1;
  font-family: 'Roboto Condensed', sans-serif;
  font-weight: normal;
  font-size: 14px;
  text-align: left;
  width: 100px;
}
.Mbt a{
  color: #a7a7a7;
  text-decoration: none;
}

.Mbt:hover a{
  color: #000;
}
</style>
